<script lang="ts">
    import s from './style.module.css';
    import {getProduct} from 'general/libs/getProduct';
    import type {AxiosInstance} from 'axios';
    import {dyData} from 'general/store';
    export let instance: AxiosInstance;
    export let image = '';
    export let colorLabel = '';
    export let colorCircle = '';
    export let name = '';

    if ($dyData.isLoadImage) {
        getProduct(instance, '1').then(res => {
            image = `/ms/media${res.data.items[0].children[0].media.front.src}`;
            colorLabel = res.data.items[0].children[0].color.label;
            colorCircle = `/ms/media${res.data.items[0].children[0].color.src}`;
            name = res.data.items[0].name;
        });
    }
</script>

<div class={s.imageContainer}>
    {#if image}
        <img class={s.image} src={image} alt={name} />
        <div class={s.info}>
            <div class={s.name}>
                {name}
            </div>
            <div class={s.colorLabel}>
                {colorLabel}
            </div>
            <img class={s.colorCircle} src={colorCircle} alt={colorLabel} />
        </div>
    {/if}
</div>
